var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            inline: "",
            "label-width": "140px",
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SearchConfiguration.Code"),
                prop: "configCode",
              },
            },
            [
              _c("BjInput", {
                attrs: { maxlength: _vm.MAX_LENGTH.DEFAULT, placeholder: "" },
                model: {
                  value: _vm.form.configCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "configCode", $$v)
                  },
                  expression: "form.configCode",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SearchConfiguration.Index"),
                prop: "indexCode",
              },
            },
            [
              _c("bj-code-select", {
                on: { change: _vm.changeIndexCode },
                model: {
                  value: _vm.form.indexCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "indexCode", $$v)
                  },
                  expression: "form.indexCode",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: { label: _vm.$t("table.statusText"), prop: "enabledFlag" },
            },
            [
              _c("el-switch", {
                attrs: { "active-value": 1, "inactive-value": 0 },
                model: {
                  value: _vm.form.enabledFlag,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "enabledFlag", $$v)
                  },
                  expression: "form.enabledFlag",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SearchConfiguration.Description"),
                prop: "remark",
              },
            },
            [
              _c("BjInput", {
                attrs: { maxlength: _vm.MAX_LENGTH.DEFAULT, placeholder: "" },
                model: {
                  value: _vm.form.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "remark", $$v)
                  },
                  expression: "form.remark",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SearchConfiguration.start"),
                prop: "activeStartTime",
              },
            },
            [
              _c("BjDateTimerPicker", {
                model: {
                  value: _vm.form.activeStartTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "activeStartTime", $$v)
                  },
                  expression: "form.activeStartTime",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SearchConfiguration.end"),
                prop: "activeEndTime",
              },
            },
            [
              _c("BjDateTimerPicker", {
                model: {
                  value: _vm.form.activeEndTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "activeEndTime", $$v)
                  },
                  expression: "form.activeEndTime",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("SearchConfiguration.add.Query"),
                name: "1",
              },
            },
            [
              _c(
                "el-tabs",
                { attrs: { "tab-position": "left", type: "border-card" } },
                [
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("SearchConfiguration.add.Custom"),
                      },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 10 } },
                            [
                              _c("vue-json-editor", {
                                attrs: {
                                  "show-btns": false,
                                  mode: "code",
                                  lang: "zh",
                                },
                                on: {
                                  "json-change": _vm.onJsonChange,
                                  "json-save": _vm.onJsonSave,
                                  "has-error": _vm.onError,
                                },
                                model: {
                                  value: _vm.resultInfo,
                                  callback: function ($$v) {
                                    _vm.resultInfo = $$v
                                  },
                                  expression: "resultInfo",
                                },
                              }),
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "mt20",
                                      attrs: { type: "primary" },
                                      on: { click: _vm.submitJson },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("saveText")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 10, offset: 4 } },
                            [
                              _c("vue-json-editor", {
                                staticClass: "read-only",
                                class: _vm.resultInfo ? "" : "hide_json",
                                attrs: {
                                  "show-btns": false,
                                  mode: "code",
                                  lang: "zh",
                                },
                                model: {
                                  value: _vm.resultInfo,
                                  callback: function ($$v) {
                                    _vm.resultInfo = $$v
                                  },
                                  expression: "resultInfo",
                                },
                              }),
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "mt20",
                                      attrs: { type: "primary" },
                                      on: { click: _vm.onTest },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SearchConfiguration.add.Test")
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("SearchConfiguration.add.Test"),
            visible: _vm.dialogVisible,
            width: "420px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "104px" } },
            [
              _vm._l(_vm.formList, function (item) {
                return _c(
                  "el-form-item",
                  { key: item, attrs: { label: item, inline: "" } },
                  [
                    _c("BjInput", {
                      attrs: {
                        maxlength: _vm.MAX_LENGTH.DEFAULT,
                        placeholder:
                          _vm.$t("SearchConfiguration.add.enter") + item,
                      },
                      model: {
                        value: _vm.testForm[item],
                        callback: function ($$v) {
                          _vm.$set(_vm.testForm, item, $$v)
                        },
                        expression: "testForm[item]",
                      },
                    }),
                  ],
                  1
                )
              }),
              _c("el-form-item", {
                attrs: { label: _vm.$t("SearchConfiguration.add.Return") },
              }),
            ],
            2
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onExecute()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("SearchConfiguration.add.Execute")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }